import { Routes, Route } from "react-router-dom";
import Home from "@src/pages/Home"
import Location from "@src/pages/Location";
import Flavors from "@src/pages/Flavors";
import WorldBestFlavorFrie from "@src/pages/WorldBestFlavorFrie";
import SuperChickenPop from "@src/pages/SuperChickenPop";
import GetInTouch from "@src/pages/GetInTouch";
import Menu from "@src/pages/Menu";
import Login from "@src/pages/BrandAMB/Login";
import BrandAmbassadorMain from "@src/pages/BrandAMB/BrandHome";

const MyRoute = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/flavors" element={<Flavors />} />
        <Route path="/worldbestflavorfrie" element={<WorldBestFlavorFrie />} />
        <Route path="/superchickenpop" element={<SuperChickenPop />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/locations" element={<Location />} />
        <Route path="/getintouch" element={<GetInTouch />} />
        <Route path="/login_brandamb" element={<Login />} />
        <Route path="/brandambassador" element={<BrandAmbassadorMain />} />
      </Routes>
    </>
  );
};

export default MyRoute;